import { render, staticRenderFns } from "./addSerial.vue?vue&type=template&id=2b18220d"
import script from "./addSerial.vue?vue&type=script&lang=js"
export * from "./addSerial.vue?vue&type=script&lang=js"
import style0 from "./addSerial.vue?vue&type=style&index=0&id=2b18220d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports